import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmtDateTime } from "@/lib/helpers";

export default function AuditLogPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/auth/audit-log").then(setItems); }, []);
  return (
    <div className="p-4 md:p-6">
      <div className="text-sm text-slate-500 mb-4">Registro delle principali operazioni · solo OWNER · ultimi 500 eventi</div>
      <Card className="card-clean overflow-hidden">
        <Table>
          <TableHeader><TableRow className="bg-slate-50">
            <TableHead>Data e ora</TableHead><TableHead>Utente</TableHead><TableHead>Ruolo</TableHead>
            <TableHead>Operazione</TableHead><TableHead>Ticket</TableHead><TableHead>Dettagli</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {items.map(a => (
              <TableRow key={a.id}>
                <TableCell className="text-xs">{fmtDateTime(a.timestamp)}</TableCell>
                <TableCell><div className="font-semibold text-sm">{a.nome}</div><div className="text-xs text-slate-500">{a.username}</div></TableCell>
                <TableCell><span className="text-xs px-1.5 py-0.5 border rounded">{a.role}</span></TableCell>
                <TableCell className="font-mono text-xs">{a.operation}</TableCell>
                <TableCell className="font-mono text-xs">{a.ticket_id}</TableCell>
                <TableCell className="text-xs text-slate-600">{a.details}</TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={6} className="text-center py-6 text-slate-500">Nessun evento registrato</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
